import React from "react";
import { useAccessLink } from "./hook";

const AccessLink = ({ single = false, data = {}, filterDelete }) => {
  const { renderCount, renderLinkName, elements, linkHandler } = useAccessLink(
    single,
    data,
    filterDelete
  );
  return (
    <div style={{ marginBottom: single ? "0px" : "10px" }}>
      {elements.map((link, key) => {
        if (renderLinkName(link)) {
          return (
            <button
              onClick={() => linkHandler(link.type)}
              key={key}
              style={{
                border: "none",
                backgroundColor: "transparent",
                fontSize: "12px",
                fontWeight: "400",
              }}
            >
              {`${renderLinkName(link)} ${renderCount() - 1 > key ? "/" : ""}`}
            </button>
          );
        }
      })}
    </div>
  );
};

export default AccessLink;
